/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input, Inject, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Iceutility } from '../../services/iceutility';
import { IcecontrolSettings, iceColumnDefinition, IcecontrolPermission } from '../../components/models/icesettings';
import { IcepanelComponent } from '../icepanel/icepanel.component';
import { IcematgridComponent } from '../icepanel/icematgrid.component';
import { userTypes } from '../../login/login.config';
import { IceexpansionpanelComponent } from '../iceexpansionpanel/iceexpansionpanel.component';

@Component({
	selector: 'iceselect',
	templateUrl: './iceselect.component.html',
  styleUrls: ['./iceselect.component.scss'],
  providers: [IceexpansionpanelComponent]
})
export class IceselectComponent implements OnInit {
  // Input Members
	@Input() placeholder: string;
  @Input() properties: any;
  @Input() ctrl: IcecontrolSettings = null;
  @Input() tableColumn: iceColumnDefinition = null;
  @Input() tableRowData: any = null;
  @Input() matTableObject: IcematgridComponent = null;

  @Output() controlChange: EventEmitter<any> = new EventEmitter<any>();

  // Data Members
  iceFormControl: FormControl = null;
  permission: IcecontrolPermission = null;

  constructor(@Inject(IcepanelComponent) private parent: IcepanelComponent,
    @Inject(IceexpansionpanelComponent) private parentExp: IceexpansionpanelComponent  ) {
	}

	ngOnInit() {
      try {
        this.permission = this.ctrl.permissions ? this.ctrl.permissions : new IcecontrolPermission(userTypes.USER_FEATURES.ufNone, userTypes.USER_FEATURE_ACCESS.ufaNone);

        // To do fix with validation
        if (this.matTableObject && this.tableRowData != null && this.tableColumn != null) {
          // tables should not use the standard formcontrol
          let formRowGroup: FormGroup = this.matTableObject.getFormGroup(this.tableRowData);
          this.iceFormControl = new FormControl(this.tableRowData[this.tableColumn.columnName]);
          formRowGroup.addControl(this.tableColumn.columnName, this.iceFormControl);
        }
        else {
          // stardard formcontrol processing
          this.iceFormControl = this.ctrl.getFormControl();
          if (this.iceFormControl == null)
            this.iceFormControl = new FormControl(false); // No control so we create a placeholder control to prevent an errors
        }

        if (this.permission.default_access === userTypes.USER_FEATURE_ACCESS.ufaReadOnly) {
          this.iceFormControl.disable();
        }
      }
      catch (e) {
        console.log(e);
      }

      if (Iceutility.isdefined(this.properties)) {
        this.ctrl.setOptions(this.properties.menuItems);
      }
  }

  isReadonly(): boolean {
    if (this.ctrl == null) return false;

    return this.ctrl.getReadonly();
  }

  isDisabled(): boolean {
    if (this.ctrl == null || this.permission == null) return false;

    if (this.ctrl.getDisabled()) return true;

    return this.permission.default_access === userTypes.USER_FEATURE_ACCESS.ufaReadOnly;
  }

  onChange(event) {
    event.selectSettings = this.ctrl;
    if (this.matTableObject && this.matTableObject.controlChange) {
      if (this.tableRowData != null && this.tableColumn != null) {
        this.tableRowData[this.tableColumn.columnName] = event.value;
        event.tableColumn = this.tableColumn;
        event.tableRowData = this.tableRowData;
      }

      this.matTableObject.onControlChange(event);
    }
    else if (this.parent && (this.parent.sections != null && this.parent.sections.length > 0) && this.parent.controlChange) {
      this.parent.onControlChange(event);
    }
    else if (this.parentExp && (this.parentExp.sections != null && this.parentExp.sections.length > 0) && this.parentExp.controlChange) {
      this.parentExp.onControlChange(event);
    }
    else {
      this.controlChange.emit(event);
    }

    // emit to control observers
    if (this.ctrl.getChangeControlEvent() != null) {
      this.ctrl.getChangeControlEvent().emit(event);
    }
  }
}
